export enum ReservationCancelReason {
  NoVehicle = "NoVehicle",
  NoDriver = "NoDriver",
  ByRequester = "ByRequester",
}

export type ReservationCancelReasonForm = null | ReservationCancelReason;
